import { render } from "./MonitoringDescription.vue?vue&type=template&id=2e2a361a&scoped=true"
import script from "./MonitoringDescription.vue?vue&type=script&lang=js"
export * from "./MonitoringDescription.vue?vue&type=script&lang=js"

import "./MonitoringDescription.vue?vue&type=style&index=0&id=2e2a361a&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2a361a"]])

export default __exports__